"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteSummaryWidget = exports.quoteSummaryWidgetDefaultSettings = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var QuoteSummaryContextProvider_1 = require("./QuoteSummaryContextProvider");
var styles = __importStar(require("./QuoteSummaryWidget.css"));
var Utils_1 = require("./Utils");
var QuoteComponents_1 = require("./QuoteComponents");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var EmptyStateTable_1 = require("./EmptyStateTable");
exports.quoteSummaryWidgetDefaultSettings = {
    showFeatureLists: true,
    showTextItems: true,
    showPlanSectionHeaders: true,
    compactLineItemDescriptions: false,
    compactSectionHeaders: false,
    showGrandTotal: true,
};
var QuoteSummaryWidgetContainer = (0, mobx_react_1.observer)(function (_a) {
    var attributes = _a.attributes, children = _a.children, quoteDataStore = _a.quoteDataStore, _b = _a.allowErrorMessaging, allowErrorMessaging = _b === void 0 ? false : _b, currencyLocaleProvider = _a.currencyLocaleProvider, settings = _a.settings;
    return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)("quote-summary-widget", styles.wrapper, attributes === null || attributes === void 0 ? void 0 : attributes.className, tokens_1.lightTheme), contentEditable: false }),
        children,
        react_1.default.createElement(MaybeErrorPlaceholder, { hasMultipleCurrencies: quoteDataStore.hasMultipleCurrencies, allowErrorMessaging: allowErrorMessaging },
            react_1.default.createElement(QuoteSummaryContextProvider_1.QuoteSummaryContextProvider, { currencyCode: quoteDataStore.currency, currencyLocale: currencyLocaleProvider.currencyLocale, showDecimals: quoteDataStore.showDecimals, getLabel: quoteDataStore.getLabel, settings: settings },
                react_1.default.createElement(Summary, { quotes: quoteDataStore.selectedQuoteItems, pageTotal: quoteDataStore.pageTotal[quoteDataStore.currency] })))));
});
exports.QuoteSummaryWidget = QuoteSummaryWidgetContainer;
var MaybeErrorPlaceholder = (0, mobx_react_1.observer)(function (_a) {
    var hasMultipleCurrencies = _a.hasMultipleCurrencies, allowErrorMessaging = _a.allowErrorMessaging, children = _a.children;
    if (hasMultipleCurrencies) {
        if (allowErrorMessaging) {
            return (react_1.default.createElement(kaleidoscope_1.Stack, null,
                react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Error creating quote summary", alertType: kaleidoscope_1.AlertType.Error }, "Oh no! There was an error creating the quote summary. Please use the same currency across all quotes to see the quote summary.")));
        }
        return null;
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
});
var Summary = function (_a) {
    var _b;
    var quotes = _a.quotes, pageTotal = _a.pageTotal;
    var settings = (0, QuoteSummaryContextProvider_1.useQuoteSummaryContext)().settings;
    var hasSelectedItems = quotes.some(function (quote) {
        return quote.sections.some(function (section) {
            if (settings.showTextItems) {
                return section.items.length > 0;
            }
            else {
                return section.items.filter(function (item) { return item.type !== Types_1.QuoteItemType.Text; }).length > 0;
            }
        });
    });
    if (quotes.length === 0 || !hasSelectedItems) {
        return (react_1.default.createElement(kaleidoscope_1.Stack, { className: "summary-wrapper", "data-is-summary-placeholder": true },
            react_1.default.createElement(EmptyStateTable_1.EmptyStateTable, null),
            react_1.default.createElement(GrandTotal, { total: {
                    preTax: 0,
                    preDiscount: 0,
                    recurringTotals: {},
                    postTax: 0,
                    oneOffTotals: { postTax: 0, preTax: 0 },
                }, labelSetId: undefined })));
    }
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: "summary-wrapper" },
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxl", className: "quotes-list" }, quotes
            .filter(function (quote) {
            if (settings.showTextItems) {
                return quote.sections.length > 0;
            }
            else {
                var sections = quote.sections.filter(function (section) {
                    return section.items.some(function (item) { return item.type !== Types_1.QuoteItemType.Text; });
                });
                return sections.length > 0;
            }
        })
            .map(function (quote, index) {
            return react_1.default.createElement(QuoteComponents_1.QuoteBlockSummary, { quote: quote, key: "quote-".concat(index) });
        })),
        react_1.default.createElement(GrandTotal, { labelSetId: (_b = quotes[0]) === null || _b === void 0 ? void 0 : _b.labelSetId, total: pageTotal })));
};
var GrandTotal = function (_a) {
    var total = _a.total, labelSetId = _a.labelSetId;
    var _b = (0, QuoteSummaryContextProvider_1.useQuoteSummaryContext)(), settings = _b.settings, formatCurrency = _b.formatCurrency, getLabel = _b.getLabel;
    if (!settings.showGrandTotal)
        return null;
    var label = (0, Utils_1.hasRecurringTotals)(total)
        ? "".concat(getLabel(labelSetId, Types_1.QuoteLabel.GrandTotal), " ").concat(getLabel(labelSetId, Types_1.QuoteLabel.DueToday))
        : getLabel(labelSetId, Types_1.QuoteLabel.GrandTotal);
    return (react_1.default.createElement(kaleidoscope_1.Stack, { align: "end", className: "grand-total-wrapper" },
        react_1.default.createElement("table", { className: (0, classnames_1.default)(styles.total, "grand-total") },
            react_1.default.createElement("tfoot", null,
                react_1.default.createElement("tr", { className: "grand-total-row" },
                    react_1.default.createElement("td", { className: styles.grandTotalCell() },
                        react_1.default.createElement("p", null, label)),
                    react_1.default.createElement("td", { className: styles.grandTotalCell({ align: "right" }) },
                        react_1.default.createElement("p", { className: styles.grandTotalValue }, formatCurrency(total.postTax))))))));
};
